import types from '../mutation-types';
import ImportantMessagesAPI from '../../api/importantMessages';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getPendingMessages(_state) {
    return _state.records;
  },
};

export const actions = {
  fetch: async function fetchMessages({ commit }) {
    commit(types.SET_IMPORTANT_MESSAGES_UI_FLAG, { isFetching: true });
    try {
      const response = await ImportantMessagesAPI.getUnread();
      commit(types.SET_IMPORTANT_MESSAGES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_IMPORTANT_MESSAGES_UI_FLAG, { isFetching: false });
    }
  },

  markAsRead: async function markMessageAsRead({ commit }, id) {
    try {
      await ImportantMessagesAPI.markAsRead(id);
      commit(types.REMOVE_IMPORTANT_MESSAGE, id);
    } catch (error) {
      // Ignore error
    }
  },
};

export const mutations = {
  [types.SET_IMPORTANT_MESSAGES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_IMPORTANT_MESSAGES](_state, data) {
    _state.records = data;
  },
  [types.REMOVE_IMPORTANT_MESSAGE](_state, id) {
    _state.records = _state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
